import React from 'react';
import { useController, Control, ControllerProps } from 'react-hook-form';
import { cn } from 'lib/utils';

interface RadioOption {
  value: string;
  label: string;
}

interface RadioGroupProps {
  name: string;
  control: Control<any>;
  options: RadioOption[];
  className?: string;
  disabled?: boolean;
  rules?: ControllerProps['rules'];
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  control,
  options,
  className,
  disabled = false,
  rules
}) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    name,
    control,
    rules
  });

  return (
    <div className={cn('space-y-3', className)}>
      {options.map((option) => (
        <div key={option.value} className="flex items-center">
          <input
            type="radio"
            id={`${name}-${option.value}`}
            value={option.value}
            checked={field.value === option.value}
            onChange={() => field.onChange(option.value)}
            disabled={disabled}
            className={cn(
              '!w-4 !h-4 text-primary outline-none border-gray-300 ring-0 focus:ring-primary focus:ring-2',
              disabled && 'opacity-50 cursor-not-allowed'
            )}
          />
          <label
            htmlFor={`${name}-${option.value}`}
            className={cn(
              'ml-3 text-sm text-text cursor-pointer',
              disabled && 'opacity-50 cursor-not-allowed'
            )}
          >
            {option.label}
          </label>
        </div>
      ))}
      {error && (
        <p className="text-sm text-destructive mt-1">
          {error.message}
        </p>
      )}
    </div>
  );
};

export { RadioGroup };